import { MountElementHandler } from '../../services/internal/MessageService/MountElementHandler';
import { myServices } from '../../services/services.connected.app';
import { CustomFieldConfigDialogWidget } from '../custom-fields/config-dialog/CustomFieldConfigDialogWidget';
import { FeatureFlagWidget } from '../feature-flag-management/FeatureFlagWidget';
import { FeatureShortcutsWidget } from '../feature-flag-management/FeatureShortcutsWidget';

export function ModalContainerV5() {
  return (
    <>
      <CustomFieldConfigDialogWidget services={myServices} />
      <FeatureFlagWidget services={myServices} />
      <FeatureShortcutsWidget services={myServices} />
      <MountElementHandler messageService={myServices.messageService} />
    </>
  );
}
